import AlarmManagement from "../pages/AlarmManagement/index";
import AllocationData from "../pages/Input_Management/Allocation_Data/index";
import AllocationDataDetail from "../pages/Input_Management/Allocation_Data/AllocationDataDetail";
import Area from "../pages/MasterData/Other/Area/index";
import BVZone from "../pages/MasterData/Other/BVZone/index";
import Balancing_ShinkgateGasData from "../pages/ManualDataEntry/Balancing_ShinkgateGasData/index";
import Bi_Dashboard from "../pages/Dashboards/Bi_Dashboard/index";
import BlockValve from "../pages/MasterData/Other/BlockValve/index";

import BookingData from "../pages/Input_Management/Booking_Data/index";
import BookingDataDetail from "../pages/Input_Management/Booking_Data/BookingDataDetail";

import QualityPointDaily from "../pages/Input_Management/QualityPointDaily/index";
import QualityPointDailyDetail from "../pages/Input_Management/QualityPointDaily/QualityPointDailyDetail";

import ViewerBooking from "../pages/ViewerReport/ViewerBooking/index";
import ViewerBookingDetail from "pages/ViewerReport/ViewerBooking/ViewerBookingDetail";

import ViewerAllocation from "../pages/ViewerReport/ViewerAllocation";
import ViewerAllocationDetail from "../pages/ViewerReport/ViewerAllocation/ViewerAllocationDetail";

import ViewerNominationDay from "../pages/ViewerReport/ViewerNominationDay/index";
import ViewerNomDayDetail from "../pages/ViewerReport/ViewerNominationDay/ViewerNominationDayDetail";

import ViewerMeteringMonth from "../pages/ViewerReport/ViewerMeteringMonth/index";
import ViewerMeteringMonthDetail from "../pages/ViewerReport/ViewerMeteringMonth/ViewerMeteringMonthDetail";

import CustomerType from "../pages/MasterData/Other/CustomerType/index";
import Daily_Dashboard from "../pages/Dashboards/Daily_Dashboard/index";
import Diesel_FuelOilData from "../pages/ManualDataEntry/Diesel_FuelOilData/index";
import FlowFuelTag from "../pages/TagMapping/FlowFuelTag/index";
import FlowLogic from "../pages/FlowLogic/index";
import FlowSelection from "../pages/FlowSelection/index";
import Flow_Fueloli from "../pages/ManualDataEntry/Flow_Fueloli/index";
import GasCompositionTag from "../pages/TagMapping/GasCompositionTag/index";
import Gas_Composition from "../pages/ManualDataEntry/Gas_Composition/index";
import Gasvolumn_Linepack from "../pages/ManualDataEntry/Gasvolumn_Linepack/index";
import IndustrialEstate from "../pages/MasterData/Other/IndustrialEstate/index";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Meter from "../pages/MasterData/Meter/index";
import VirtualMeter from "../pages/MasterData/VirtualMeter/index";
import MeteringDaily from "../pages/Input_Management/Metering_Data/MeteringDaily/index";
import MeteringDailyDetail from "../pages/Input_Management/Metering_Data/MeteringDaily/MeteringDailyDetail";
import MeteringMonthly from "../pages/Input_Management/Metering_Data/MeteringMonthly/index";
import MeteringMonthlyDetail from "../pages/Input_Management/Metering_Data/MeteringMonthly/MeteringMonthlyDetail";
import Nomination from "../pages/MasterData/Other/Nomination/index";
import NominationDay from "../pages/Input_Management/Normination_Data/NominationDay/index";
import NominationDayDetail from "../pages/Input_Management/Normination_Data/NominationDay/NominationDayDetail";
import NominationWeek from "../pages/Input_Management/Normination_Data/NominationWeek/index";
import NominationWeekDetail from "../pages/Input_Management/Normination_Data/NominationWeek/NominationWeekDetail";
import OtherKeyinData from "../pages/ManualDataEntry/OtherKeyinData/index";
import Person from "../pages/MasterData/Shipper/Person";
import Point from "../pages/MasterData/Other/Point/index";
import QualityPoint from "../pages/MasterData/Other/QualityPoint/index";
import React from "react";
import { Redirect } from "react-router-dom";
import Region from "../pages/MasterData/Other/Region/index";
import Remark1 from "../pages/MasterData/Other/Remark1/index";
import Remark2 from "../pages/MasterData/Other/Remark2/index";
import Remark3 from "../pages/MasterData/Other/Remark3/index";
import Remark4 from "../pages/MasterData/Other/Remark4/index";
import Remark5 from "../pages/MasterData/Other/Remark5/index";
import Zone from "../pages/MasterData/Other/Zone/index";
import Shipper from "../pages/MasterData/Shipper/index";
import SubArea from "../pages/MasterData/Other/SubArea/index";
import SummaryReport from "../pages/SummaryReport/index";

import RoleDetail from "../pages/UserManagement/RoleManagement/RoleDetail";
import RoleManagement from "../pages/UserManagement/RoleManagement/index";
import UserManagement from "../pages/UserManagement/UserManagement/index";
import EmailManagement from "../pages/UserManagement/EmailManagement/index";

import DashboardURL from "../pages/DashboardURL/index";
import APISchedule from "../pages/SystemConfig/APIScheduleRun/index";
import APIParameter from "../pages/SystemConfig/APIParameter/index";
import DataSourceConnection from "pages/SystemConfig/DataSourceConnection/index";

//Report//
import TPADailyReport from "../pages/Report/TPADailyReport/index";
import TabTPADaily from "../pages/Report/TPADailyReport/TabTPADaily";

import GasCompositionReport from "pages/Report/GasCompositionReport/index";
import GCNameDailyDetail from "pages/Report/GasCompositionReport/GCNameDailyDetail";

import EODSummaryReport from "pages/Report/EODSummaryReport/index";
import TPABalancingAndOveruse from "pages/Report/TPABalancingAndOveruseReport/index";
import PipelineUtilizationReport from "pages/Report/PipelineUtilizationReport/index";

import AverageGasDeliveryReport from "pages/Report/AverageGasDeliveryReport/index";
import AverageGasDetail from "pages/Report/AverageGasDeliveryReport/AverageGasDetail";

import GasDeliveryPerformanceReport from "pages/Report/GasDeliveryPerformanceReport/index";
import GasDeliveryPerformanceDetail  from "pages/Report/GasDeliveryPerformanceReport/GasDeliveryPerformanceDetail";

import ShiftReport from "pages/Report/ShiftReport/index";
import DetailShiftReport from "pages/Report/ShiftReport/DetailShiftReport";

import DeliveryGasFuelGasReport from "pages/Report/DeliveryGasFuelGasReport/index";
import DetailDeliveryGasFuelGas from "pages/Report/DeliveryGasFuelGasReport/DetailDeliveryGasFuelGas";

import ActualSupplyDemand from "pages/Report/ActualSupplyDemand/index";
import DetailActualSupplyDemand from "pages/Report/ActualSupplyDemand/ActualDemandDetail";

//Report//
// import FlowSelectionDetail from "../pages/FlowSelection/FlowSelectionDetail";


// import { getPermission } from "../helpers/auth_helper";



































// import Booking_Data from "../pages/Input_Management/Booking_Data1/index";
















// import MeteringDailyDetail from "../pages/Input_Management/Metering_Data/MeteringDaily/MeteringDailyDetail";
















// import Customer from "../pages/MasterData/Other/Customer/index";












// Authentication related pages




// const permission = getPermission();


const authProtectedRoutes = [

    { path: "/dashboard", component: Daily_Dashboard },
    { path: "/bi-dashboard", component: Bi_Dashboard },

    { path: "/booking-data", component: BookingData },
    { path: "/booking-data/:pid/booking-data-detail", component: BookingDataDetail },

    { path: "/nomination-week", component: NominationWeek },
    { path: "/nomination-week/:pid/nomination-week-detail", component: NominationWeekDetail },

    { path: "/nomination-day", component: NominationDay },
    { path: "/nomination-day/:pid/nomination-day-detail", component: NominationDayDetail },

    { path: "/allocation-data", component: AllocationData },
    { path: "/allocation-data/:pid/allocation-data-detail", component: AllocationDataDetail },

    { path: "/metering-data-daily", component: MeteringDaily },
    { path: "/metering-data-daily/:pid/metering-data-daily-detail", component: MeteringDailyDetail },

    { path: "/metering-data-monthly", component: MeteringMonthly },
    { path: "/metering-data-monthly/:pid/metering-data-monthly-detail", component: MeteringMonthlyDetail },

    { path: "/quality-point-daily", component: QualityPointDaily },
    { path: "/quality-point-daily/:date/:source/quality-point-daily-detail", component: QualityPointDailyDetail },

    { path: "/viewer-booking", component: ViewerBooking },
    { path: "/viewer-booking/:pid/viewer-booking-detail", component: ViewerBookingDetail },

    { path: "/viewer-allocation", component: ViewerAllocation },
    { path: "/viewer-allocation/:pid/viewer-allocation-detail", component: ViewerAllocationDetail },

    { path: "/viewer-nomination-day", component: ViewerNominationDay },
    { path: "/viewer-nomination-day/:pid/viewer-nomination-day-detail", component: ViewerNomDayDetail },  

    { path: "/viewer-metering-month", component: ViewerMeteringMonth },
    { path: "/viewer-metering-month/:pid/viewer-metering-month-detail", component: ViewerMeteringMonthDetail },  

    // { path: "/flow-selection/:mode/:pid/flow-selection-detail", component: FlowSelectionDetail},
    { path: "/flow-selection", component: FlowSelection },
    { path: "/flow-logic", component: FlowLogic },
    { path: "/gas-volumn-line-pack", component: Gasvolumn_Linepack },
    { path: "/flow-fuel-Monthly-Daily", component: Flow_Fueloli },
    { path: "/balancing-shinkgate-gas-data", component: Balancing_ShinkgateGasData },
    { path: "/diesel-fuel-oil-data", component: Diesel_FuelOilData },
    { path: "/other-key-in-data", component: OtherKeyinData },
    { path: "/gas-composition", component: Gas_Composition },
    { path: "/alarm-management", component: AlarmManagement },

    { path: "/shipper", component: Shipper },
    { path: "/shipper/:pid/person", component: Person },

    { path: "/meter", component: Meter },
    { path: "/virtual-meter", component: VirtualMeter },
    // { path: "/customer", component: Customer },
    { path: "/customer-type", component: CustomerType },
    { path: "/zone", component: Zone },
    { path: "/point", component: Point },
    { path: "/region", component: Region },
    { path: "/nomination", component: Nomination },
    { path: "/area", component: Area },
    { path: "/sub-area", component: SubArea },
    { path: "/bv-zone", component: BVZone },
    { path: "/block-valve", component: BlockValve },
    { path: "/industrial-estate", component: IndustrialEstate },
    { path: "/quality-point", component: QualityPoint },
    { path: "/remark1", component: Remark1 },
    { path: "/remark2", component: Remark2 },
    { path: "/remark3", component: Remark3 },
    { path: "/remark4", component: Remark4 },
    { path: "/remark5", component: Remark5 },

    { path: "/role-management", component: RoleManagement },
    { path: "/role-management/:pid/role-management-detail", component: RoleDetail },

    { path: "/user-management", component: UserManagement },
    { path: "/e-mail-management", component: EmailManagement },
    { path: "/summary-report", component: SummaryReport },
    { path: "/gas-compostion-tag", component: GasCompositionTag },
    { path: "/flow-fuel-tag", component: FlowFuelTag },
    { path: "/dashboard-url", component: DashboardURL },
    { path: "/api-schedule-run", component: APISchedule },
    { path: "/api-parameter", component: APIParameter },
    { path: "/datasource-connection", component: DataSourceConnection },

    //Report//
    { path: "/tpa-daily-report", component: TPADailyReport },
    { path: "/tpa-daily-report/:pid/tpa-daily-report-detail", component: TabTPADaily },

    { path: "/gas-composition-report", component: GasCompositionReport },
    { path: "/gas-composition-report/:pid/gas-composition-report-detail", component: GCNameDailyDetail },

    { path: "/eod-summary-report", component: EODSummaryReport },
    { path: "/tpa-balancing-and-overuse-report", component: TPABalancingAndOveruse },
    { path: "/pipeline-utilization-report", component: PipelineUtilizationReport },

    { path: "/gas-delivery-performance-report", component: GasDeliveryPerformanceReport },
    { path: "/gas-delivery-performance-report/:year/gas-delivery-performance-report-detail", component: GasDeliveryPerformanceDetail },

    { path: "/average-gas-delivery-report", component: AverageGasDeliveryReport },
    { path: "/average-gas-delivery-report/:pid/:date/average-gas-delivery-report-detail", component: AverageGasDetail },

    { path: "/delivery-gas-fuel-gas-report", component: DeliveryGasFuelGasReport },
    { path: "/delivery-gas-fuel-gas-report/:pid/:date/delivery-gas-fuel-gas-report-detail", component: DetailDeliveryGasFuelGas },

    { path: "/shift-report", component: ShiftReport },
    { path: "/shift-report/:pid/:date/shift-report-detail", component: DetailShiftReport },

    { path: "/actual-supply-demand-actual-gsm", component: ActualSupplyDemand },
    { path: "/actual-supply-demand-actual-gsm/:date/actual-supply-demand-actual-gsm-detail", component: DetailActualSupplyDemand},
    //Report//

    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name
    { path: "/", exact: true, component: () => < Redirect to="/dashboard" /> },
];
const publicRoutes = [
    { path: "/logout", component: Logout },
    { path: "/login", component: Login },
];
export { authProtectedRoutes, publicRoutes };